import { Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageService } from '../../shared/services/message/message.service';
import { INutrientPlanGroup } from '../../shared/services/nutrient-plan-group/nutrient-plan-group.model';
import { NutrientPlanGroupService } from '../../shared/services/nutrient-plan-group/nutrient-plan-group.service';
import { SeasonService } from '../../shared/services/season/season.service';
import { UserService } from '../../shared/services/user/user.service';

@Component({
  selector: 'gk-add-nutrient-plan-modal',
  templateUrl: './add-nutrient-plan-modal.component.html'
})
export class AddNutrientPlanModalComponent {
  nutrientPlanGroup: INutrientPlanGroup;
  addPlanForm: UntypedFormGroup;

  constructor(
    private router: Router,
    private messageService: MessageService,
    private seasonService: SeasonService,
    private dialogRef: MatDialogRef<AddNutrientPlanModalComponent>,
    private nutrientPlanGroupService: NutrientPlanGroupService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.nutrientPlanGroup = this.nutrientPlanGroup ?? <INutrientPlanGroup>{};
  }

  savePlan() {
    this.nutrientPlanGroup.seasonId =
      this.seasonService.displaySeasonForOrganisation();
    if (!this.nutrientPlanGroup.regionId) {
      this.nutrientPlanGroup.regionId = this.userService.userRegionIds()[0];
    }

    this.nutrientPlanGroupService
      .createPlanGroup(this.nutrientPlanGroup)
      .then(id => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.router.navigate(['/nutrient-management/manage', id]);
      })
      .catch(() => {
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'UNABLE_TO_CREATE_NUTRIENT_PLAN'
        );
      })
      .finally(() => this.dialogRef.close());
  }

  close() {
    this.dialogRef.close(false);
  }
}
